/**
 * Search params for the signed-out redirect from an /account page. MCP links
 * carry a one-time ticket or secret id in the URL, so those pages send the
 * visitor back after sign-in; other account pages keep the existing behavior.
 */
export function loginRedirectSearch(
  pathname: string,
  searchStr: string,
): { return_to?: string } {
  if (!pathname.startsWith('/account/mcp/')) return {};
  return { return_to: `${pathname}${searchStr}` };
}
